export default __webpack_public_path__ + "static/char-02-anr-071c38f2fb5f4780c7eb9ec14641836f.gif";